module.exports = __webpack_public_path__ + "static/media/m_hairstyle_suave_front_vector.1aad2d57.svg";